import React, { Suspense, lazy } from "react";
import "@/App.css";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import MaxFitness from "@/components/landing/MaxFitness";
import NotFoundPage from "@/components/landing/NotFoundPage";
import { Routes, Route, useLocation } from "react-router-dom";
import CookieConsentBanner from "@/components/landing/CookieConsentBanner";
import { readCookieConsent } from "@/lib/cookieConsent";

const AdminPage = lazy(() => import("@/components/admin/AdminPage"));
const PrivacyPolicyPage = lazy(() => import("@/components/landing/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("@/components/landing/TermsPage"));
const CookiesPolicyPage = lazy(() => import("@/components/landing/CookiesPolicyPage"));

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const allowAnalytics = () => readCookieConsent().analytics;
  const allowSpeedInsights = () => readCookieConsent().speedInsights;

  return (
    <div className="App">
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<MaxFitness />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      {!isAdminRoute && <CookieConsentBanner />}
      {!isAdminRoute && <Analytics beforeSend={(event) => (allowAnalytics() ? event : null)} />}
      {!isAdminRoute && <SpeedInsights beforeSend={(event) => (allowSpeedInsights() ? event : null)} />}
    </div>
  );
}

export default App;
